import { render, staticRenderFns } from "./person.vue?vue&type=template&id=1e27fb04&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&id=1e27fb04&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e27fb04')) {
      api.createRecord('1e27fb04', component.options)
    } else {
      api.reload('1e27fb04', component.options)
    }
    module.hot.accept("./person.vue?vue&type=template&id=1e27fb04&", function () {
      api.rerender('1e27fb04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/person/person.vue"
export default component.exports